import { SVGProps } from 'react';

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2.8125C9.31066 2.8125 9.5625 3.06434 9.5625 3.375V13.267L13.6648 9.16475C13.8844 8.94508 14.2406 8.94508 14.4602 9.16475C14.6799 9.38442 14.6799 9.74058 14.4602 9.96025L9.39775 15.0227C9.17808 15.2424 8.82192 15.2424 8.60225 15.0227L3.53975 9.96025C3.32008 9.74058 3.32008 9.38442 3.53975 9.16475C3.75942 8.94508 4.11558 8.94508 4.33525 9.16475L8.4375 13.267V3.375C8.4375 3.06434 8.68934 2.8125 9 2.8125Z"
        fill="currentColor"
      />
    </svg>
  );
};
